import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon, IconEnum, Messages, MessageSenders, UserPhotoIcon } from '@investoro/core';
import { UserMessages } from 'store/User/State';
import styled from 'styled-components';

const Wrapper = styled.div`
    position: relative;
    display: inline-block;
`;

const UserInfoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: right;
    height: fit-content;
    flex-wrap: nowrap;
    gap: 5px;
`;

const Options = styled.div`
    position: absolute;
    right: 0;
    top: 40px;
    background: var(--color-white);
    border-radius: var(--box-border-radius);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-left: auto;
    z-index: var(--z-index-options-menu);
    min-width: 265px;
`;

const ButtonContainer = styled.div`
    display: flex;
    margin-left: auto;
    align-items: center;
    padding: 20px;
    border-radius: 50px;
    color: var(--color-primary);
    gap: 8px;
    background-color: var(--color-alt-second);
    min-width: 40px;
    height: 50px;

    &:hover {
        transition: background-color ease-in .2s;
        background-color: var(--color-alt);
        cursor: pointer;

        p {
            color: white;
        }

        img {
            filter: ${(props) => props.darkMode ? 'unset' : 'invert(100%) sepia(100%) saturate(0%) hue-rotate(79deg) brightness(105%) contrast(102%)'};
        }

        & .user-photo-icon-img {
            filter: none;
        }
    }
`;

export interface User {
    profileId: string;
    userName: string;
    title: string;
    userPhoto?: string;
    price: string;
    offerPhoto: string;
    handleSendMessages: (message: string) => void;
    userMessages: UserMessages[];
    showMessageButton?: boolean;
}

interface OptionsContainerProps {
        userDetails?: User;
        showUserOptions?: boolean;
}

const OptionsContainer: FC<OptionsContainerProps> = ({ userDetails, showUserOptions }) => {
    const [isUserNameOptionsShown, setIsUserNameOptionsShown] = useState(false);
    const [referenceElement, setReferenceElement] = useState(null);
    const [showMessages, setShowMessages] = useState(false);
    const navigate = useNavigate();

    const handleUserNameOptions = (e: Event) => {
        e.stopPropagation();
        setIsUserNameOptionsShown((prev) => !prev);
    };

    const goToProfile = (e: Event) => {
        e.stopPropagation();
        navigate(`/profile/${userDetails!.profileId}`);
    };

    const handleMessages = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        setShowMessages((prev) => !prev);
    };

    return (
        <>
            <Wrapper>
                {userDetails &&
            <UserInfoContainer onClick={handleUserNameOptions}>
                <UserPhotoIcon img={userDetails.userPhoto} />
                <span>{userDetails.userName}</span>
            </UserInfoContainer>}
                {isUserNameOptionsShown && userDetails && userDetails.showMessageButton && showUserOptions &&
                    <Options ref={setReferenceElement}>
                        <ButtonContainer onClick={goToProfile}>
                            {userDetails.userPhoto ? <UserPhotoIcon img={userDetails.userPhoto}/> : <Icon icon={IconEnum.USER}/>}
                            <p>Inne oferty użytkownika</p>
                        </ButtonContainer>
                        <ButtonContainer>
                            <Icon icon={IconEnum.EMAIL}/>
                            <p>Wyślij wiadomość</p>
                        </ButtonContainer>
                    </Options>
                }
            </Wrapper>
            {showMessages && userDetails && userDetails.userName &&
                    <Messages username={userDetails.userName} referenceElement={referenceElement}
                        onClose={handleMessages} title={userDetails.title}
                        photo={userDetails.offerPhoto}
                        price={userDetails.price}
                        onSendMessage={userDetails.handleSendMessages}
                        messages={userDetails.userMessages}
                        messageOwnerType={MessageSenders.INTERESTED}
                        isPopup
                    />}

        </>);
};

export default OptionsContainer;
